var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardSalesReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75 2.75V19.25H19.25",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25 9.16667H7.33333C6.82707 9.16667 6.41667 9.57707 6.41667 10.0833V14.6667C6.41667 15.1729 6.82707 15.5833 7.33333 15.5833H8.25C8.75626 15.5833 9.16667 15.1729 9.16667 14.6667V10.0833C9.16667 9.57707 8.75626 9.16667 8.25 9.16667Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8333 5.5H11.9167C11.4104 5.5 11 5.91041 11 6.41667V14.6667C11 15.1729 11.4104 15.5833 11.9167 15.5833H12.8333C13.3396 15.5833 13.75 15.1729 13.75 14.6667V6.41667C13.75 5.91041 13.3396 5.5 12.8333 5.5Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.4167 11.9167H16.5C15.9937 11.9167 15.5833 12.3271 15.5833 12.8333V14.6667C15.5833 15.1729 15.9937 15.5833 16.5 15.5833H17.4167C17.9229 15.5833 18.3333 15.1729 18.3333 14.6667V12.8333C18.3333 12.3271 17.9229 11.9167 17.4167 11.9167Z",
    stroke: "#E60D1E",
    strokeWidth: 1.60417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSalesReport);
export default __webpack_public_path__ + "static/media/card-sales-report.5bbe2a288519f32760f64fe2001df8bd.svg";
export { ForwardRef as ReactComponent };